<template>
    <div class="echart-line"  ref="echartsLineRef" style="height: 400px; width: 100%"></div>
</template>

<script>
import * as echarts from 'echarts';
import macarons from  '@/apis/macarons'
import {getHomeExpenseLine} from "@/apis/static";
export default {
    name: 'EchartLine',
    props : {
        search : Object
    },
    components: {

    },
    data () {
        return {
            option: {
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['员工报销']
                },
                grid: {
                    left: '1%',
                    right: '1%',
                    bottom: '1%',
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        saveAsImage: {}
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: [],
                    axisLabel: {
                        rotate: 30 // 旋转45度
                    }
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        name: '员工报销',
                        type: 'line',
                        stack: 'Total',
                        data: []
                    }
                ]
            }
        }
    },
    created(){

    },
    mounted(){
        this.$nextTick(() => {
            this.GetLineEchart();
        })
    },
    methods:{
        GetLineEchart(){
            let that = this;
            getHomeExpenseLine().then(e=>{
                that.option.xAxis.data = e.data.date ?? [];
                that.option.series[0].data = e.data.money_data ?? [];
                const chartDom = that.$refs.echartsLineRef;
                echarts.registerTheme('macarons', macarons);
                const myChart = echarts.init(chartDom, macarons);
                myChart.setOption(that.option);
            })
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">

</style>
